import React from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "../../redux/hooks.ts";

interface Props {
  children: React.ReactNode;
}

export const PublicMiddleware: React.FC<Props> = ({ children }) => {
  const { token } = useAppSelector((state) => state.auth);
  const isAuthorized = !!token;

  return <>{!isAuthorized ? children : <Navigate to="/" />}</>;
};
